export const GENERIC_ERROR_MESSAGE = 'Ocorreu um erro, por favor tente mais tarde.';
export const INCORRECT_EMAIL_OR_PASSWORD = 'Email ou senha incorreta.';
export const TOO_MANY_TRIES = 'Muitas tentativas, aguarde 1 minuto ou redefina sua senha.';
